export default __webpack_public_path__ + "static/media/Bill-Perkins.aa691de9.png";